var 
	Menu,
	$body,
	$window
;

(function($){

	Menu = {

		$ : null,

		body : function(){
			return $body;
		},

		window : function(){
			return $window;
		},

		init : function(){

			$body = $( 'body' );
			$window = $( 'window' );

			this.$ = $( '#menu-principal' );
			this.$items = $( '#menu-principal' ).children( 'li' );
			this.$.find( 'a[href="#"]' ).off( 'click' ).on( 'click', function(e){

				e.preventDefault();

				this.$ = this.$ || $( this );
				this.$p = this.$p || this.$.parents( 'li' ).first();
				this.$c = this.$c || this.$p.find( 'ul.sub-menu' );

				// Close all
				Menu.$items.not( this.$p ).removeClass( 'open' );

				// Toggle item
				if( this.$c.length ){
					this.$p.toggleClass( 'open' );
				}
				
			});

			$window.on( 'click', function( e ){

				console.info( "fasfasdf" );
				
			});
		
		}
		
	}
	$(function(){
		Menu.init();
	});

})(jQuery);
